import * as React from "react";

import type { CheckBoxProps } from "./CheckBox.props";

const CheckBox = ({ id, label, onChange, checked, disabled = false }: CheckBoxProps) => (
	<div className="checkbox">
		<label htmlFor={`${id}_check`}>
			<input
				type="checkbox"
				id={`${id}_check`}
				name={`${id}_check`}
				checked={checked}
				disabled={disabled}
				onChange={onChange}
			/>
			{label}
		</label>
	</div>
);

export { CheckBox }
